// =============================================================================
// LIL & CO — WhatsApp inbox (helpers purs)
// =============================================================================
// La fenêtre de service Meta (24h) s'ouvre quand le CLIENT écrit en premier.
// Tant qu'elle est ouverte, on répond en texte libre (relais humain). Fermée,
// il faut un template approuvé. Ces helpers calculent l'état de la fenêtre.
// =============================================================================

export interface WaSession {
  id: string;
  wa_id: string;
  tenant_id: string | null;
  contact_name: string | null;
  last_inbound_at: string | null;
  window_expires_at: string | null;
  first_reply_sent: boolean | null;
  opted_in_marketing: boolean | null;
  opted_in_at: string | null;
  converted: boolean | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface WaMessage {
  id: string;
  tenant_id: string | null;
  wa_id: string;
  direction: string; // 'in' | 'out'
  body: string | null;
  wa_message_id: string | null;
  status: string | null;
  created_at: string;
}

/** Fenêtre 24h encore ouverte ? (répondre en texte libre autorisé) */
export function windowOpen(session: WaSession, now: Date = new Date()): boolean {
  if (!session.window_expires_at) return false;
  const exp = new Date(session.window_expires_at).getTime();
  return Number.isFinite(exp) && exp > now.getTime();
}

/** Minutes restantes avant fermeture de la fenêtre (0 si fermée). */
export function windowMinutesLeft(session: WaSession, now: Date = new Date()): number {
  if (!session.window_expires_at) return 0;
  const ms = new Date(session.window_expires_at).getTime() - now.getTime();
  return ms > 0 ? Math.round(ms / 60000) : 0;
}

/** Libellé humain du temps restant (« 3 h 12 » ou « fermée »). */
export function windowLabel(session: WaSession, now: Date = new Date()): string {
  const m = windowMinutesLeft(session, now);
  if (m <= 0) return 'fermée';
  const h = Math.floor(m / 60);
  const min = m % 60;
  return h > 0 ? `${h} h ${String(min).padStart(2, '0')}` : `${min} min`;
}

export interface InboxStats {
  totalSessions: number;
  openWindows: number;
  converted: number;
  optedIn: number;
}

export function inboxStats(sessions: WaSession[], now: Date = new Date()): InboxStats {
  return {
    totalSessions: sessions.length,
    openWindows: sessions.filter((s) => windowOpen(s, now)).length,
    converted: sessions.filter((s) => s.converted).length,
    optedIn: sessions.filter((s) => s.opted_in_marketing).length,
  };
}
